import React, { useState, useContext } from 'react';
import { faCog, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';

import { ConfiguracaoSistemaContexto } from './../ConfiguracaoSistemaContexto';
import ComboModeloEmail from './../../Componentes/ComboModeloEmail';

// configura email de cancelamento de participante
export default function ConfiguraEmailSeguroAventuraCancelamento(){

    // estados
    const { chaves } = useContext(ConfiguracaoSistemaContexto);
    const [salvando, alterarSalvando] = useState(false);

    // salva valor novo
    async function salvar(idNovo){
        alterarSalvando(true);

        try {

            await axios.put(`/configuracaoSistema/modeloEmailSeguroAventuraParticipanteCancelamento`, {
                valor: idNovo
            });

        } catch({ response }) {
            console.error(response);
            alert("Houve um erro ao salvar");
        } finally {
            alterarSalvando(false);
        }
    }

    return (
        <div className="d-flex">
            <div className="flex-grow-1 p-1">
                Modelo de email utilizado para quando o participante do seguro de aventura é cancelado
            </div>
            <div style={{width: '300px'}}>
                <ComboModeloEmail 
                    id={chaves.modeloEmailSeguroAventuraParticipanteCancelamento}
                    alterou={idNovo => {
                        salvar(idNovo);
                    }}
                    tipo={3}
                />
            </div>
            <div className="carregador pt-2 pb-2 pr-5">
                <FontAwesomeIcon 
                    className={[salvando ? 'text-success' : 'text-light'].join(` `)} 
                    icon={salvando ? faSpinner : faCog} pulse={salvando} 
                /> 
            </div>
        </div>
    )

}